import {Component, Renderer2, OnInit, OnDestroy} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {HeaderComponent} from '../templates/header/header.component';
import {FooterComponent} from '../templates/footer/footer.component';
import {PlanDetailComponent} from '../plan-detail/plan-detail.component';
import {PlanDashboardComponent} from '../plan-dashboard/plan-dashboard.component';
import {LodgeFieldRecordComponent} from '../lodge-field-record/lodge-field-record.component';
import {UserAccountDetailsComponent} from '../user-account-details/user-account-details.component';
import {NAV_MENUS} from '../common/constants';
import {PermissionsService} from '../common/service/permissions.service';
import {NlrHasPermissionsPipe} from '../common/pipe/nlr-has-permissions.pipe';

@Component({
    selector: 'nlr-home',
    imports: [
        HeaderComponent,
        FooterComponent,
        PlanDetailComponent,
        PlanDashboardComponent,
        LodgeFieldRecordComponent,
        UserAccountDetailsComponent,
        RouterLink,
        RouterLinkActive,
        NlrHasPermissionsPipe
    ],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit, OnDestroy {
    title: string = NAV_MENUS.HOME;

    lodgeFieldRecordPermissions = ['LODGE_FIELD_RECORD'];
    maintainFirmPermissions = ['MAINTAIN_FIRM'];

    constructor(
        private renderer: Renderer2,
        private permissionsService: PermissionsService
    ) {}

    ngOnInit(): void {
        this.renderer.addClass(document.body, 'home-active');
    }

    ngOnDestroy(): void {
        this.renderer.removeClass(document.body, 'home-active');
    }

    hasLodgeFieldRecordPermissions() {
        return this.permissionsService.hasPermission(this.lodgeFieldRecordPermissions);
    }

    hasMaintainFirmPermissions() {
        return this.permissionsService.hasPermission(this.maintainFirmPermissions);
    }
}
